import React, { useState, useRef, useEffect, useContext } from "react";
import "./RangeSilder.scss";
import { ResumePopupContext } from "../../Context/resumePopupContext";

function RangeSilder(props) {
  const ref = useRef();

  useEffect(() => {
    const percent =
      ((ref.current.value - ref.current.min) /
        (ref.current.max - ref.current.min)) *
      100;
    // Here comes the magic 🦄🌈
    ref.current.style.setProperty("--webkitProgressPercent", `${percent}%`);

    if (props.color) {
      if (props.skillColor && props.skillColor.c_hundred != "") {
        if (props.value > 79 && props.value <= 100) {
          ref.current.style.setProperty(
            "--progressBg",
            props && props.skillColor && props.skillColor.c_hundred
          );
        } else if (props.value > 59 && props.value <= 79) {
          ref.current.style.setProperty(
            "--progressBg",
            props && props.skillColor && props.skillColor.c_eighty
          );
        } else if (props.value > 39 && props.value <= 59) {
          ref.current.style.setProperty(
            "--progressBg",
            props && props.skillColor && props.skillColor.c_sixty
          );
        } else if (props.value > 19 && props.value <= 39) {
          ref.current.style.setProperty(
            "--progressBg",
            props && props.skillColor && props.skillColor.c_forty
          );
        } else {
          ref.current.style.setProperty(
            "--progressBg",
            props && props.skillColor && props.skillColor.c_twenty
          );
        }
      } else {
        ref.current.style.setProperty("--progressBg", props.color);
      }
    }
    if (props.trackSize) {
      ref.current.style.setProperty("--trackSize", props.trackSize);
    }
    if (props.thumbSize) {
      ref.current.style.setProperty("--thumbSize", props.thumbSize);
    }
    if (props.thumbBg) {
      ref.current.style.setProperty("--thumbBg", props.thumbBg);
    }
  }, [props.value]);

  const { preview, setPreview } = useContext(ResumePopupContext);

  return (
    <>
      <input
        ref={ref}
        type="range"
        className="range_slider "
        min="0"
        max="100"
        name="level"
        value={props.value}
        onChange={!preview ? props.resumeHandler : ""}
        onBlur={props.onBlur}
      />
    </>
  );
}

export default RangeSilder;
